import React, { useState, useEffect } from 'react';
import SectionMenuBar, { SectionMenuBarReducer } from '../../../components/section-menu/show-and-hide';
import { questions } from './data/questions';
import { UrlService } from '../../../core/services/UrlService';
import Layout from '../../../components/layout';
import Seo from '../../../components/seo';
import './index.scss';
import Hero from './components/hero';
import Content from './components/content';
import $ from 'jquery';
import SelfTestSection from '../../../components/self-test/SelfTestSection';
import HPyloriSelfTestResult from './components/self-test-result';
import ReferenceListSection from '../../../components/reference-list/ReferenceListSection';
import { config } from './data/config';
import { useCmsCampaign } from '../../../cms/hooks/useCmsCampaign';

const HPyloriSelfTest: React.FC = () => {
    const [state, dispatch] = React.useReducer(SectionMenuBarReducer, {
        anchorId: 'intro',
    });

    const [isInit, setIsInit] = React.useState(true);

    const { campaign, layoutConfig, seoConfig } = useCmsCampaign('hpylori');

    React.useEffect(() => {
        if (isInit) {
            setIsInit(false);
        } else {
            $("html, body").animate({ scrollTop: $('.self-test__content-sections').position()?.top - 150 || 0 }, 600);
        }
    }, [state]);

    const menuBarData = [
        { anchorId: 'intro', name: 'intro', href: '#intro' },
        { anchorId: '成因', name: '成因', href: '#cause' },
        { anchorId: '症狀', name: '症狀', href: '#symptom' },
        { anchorId: '診斷', name: '診斷', href: '#diagnosis' },
        { anchorId: '治療', name: '治療', href: '#treatment' },
    ];

    return (
        <Layout {...layoutConfig}>
            <Seo {...seoConfig} />
            <div className="self-test patient-care_hpylori">
                <Hero
                    reducer={[state, dispatch]}
                />
                <SectionMenuBar
                    permalink={UrlService.getBaseUrl('/patient-care/h-pylori')}
                    data={menuBarData}
                    reducer={[state, dispatch]}
                />
                <section className="self-test__content-sections">
                    <Content
                        id='intro'
                        image={UrlService.getLocalImageUrl('patient-care/h-pylori/q1_608x567.png')}
                        reducer={[state, dispatch]}
                        next="成因"
                    >
                        <h2>&nbsp;</h2>
                        <p>
                            經常腸胃不適，吃過腸胃炎藥物還是未能改善狀況，有機會是感染了幽門螺旋桿菌！幽門螺旋桿菌存活於胃部，主要棲息在酸性的胃黏液或胃黏膜細胞中，有時也會生長在口腔中。<sup>1,2</sup>據統計香港一半以上的人口都感染了幽門螺旋桿菌<sup>2</sup>，感染後如未有及早治療，有機會引致胃炎、胃潰瘍，甚至胃癌。<sup>3</sup>
                        </p>
                    </Content>
                    <Content
                        id='成因'
                        image={UrlService.getLocalImageUrl('patient-care/h-pylori/section_1_511x524.png')}
                        reducer={[state, dispatch]}
                        next="症狀"
                    >
                        <h2>成因</h2>
                        <p>
                            根據專家推測，幽門螺旋桿菌主要透過唾液、嘔吐物、糞便、受污染或未煮熟的食物盒和受污染的飲用水傳播<sup>4</sup>。
                        </p>
                        <p>
                            因此幽門螺旋桿菌有機會在家庭內傳播，如果其中一位家庭成員感染了幽門螺旋桿菌，其伴侶或子女同時受感染的機會分別為68%和40%<sup>5</sup>。
                        </p>
                    </Content>
                    <Content
                        id='症狀'
                        image={UrlService.getLocalImageUrl('patient-care/h-pylori/section_2_552x525.png')}
                        reducer={[state, dispatch]}
                        next="診斷"
                    >
                        <h2>症狀</h2>
                        <p>
                            感染幽門螺旋桿菌後，雖然大多患者都不會表現出任何症狀，但幽門螺旋桿菌可導致慢性及萎縮性胃炎，以及十二指腸和胃部潰瘍<sup>3</sup>。此外，幽門螺旋桿菌的感染者患上胃癌和胃黏膜相關淋巴組織淋巴瘤的機會是一般人的2-6倍<sup>3</sup>，當中胃癌更是癌症中的第三號殺手<sup>6</sup>。
                                </p>
                        <p>
                            至於有症狀的幽門螺旋桿菌感染者，他們通常會感到上腹悶痛或灼痛，痛楚通常發生在餐與餐之間和清早時分，持續幾分鐘到幾個小時不等，且通常能透過進食或服用制酸劑舒緩<sup>3</sup>。
                        </p>
                        <p>
                            其他相對較少見的症狀包括：<sup>3</sup>
                        </p>
                        <ul>
                            <li>噁心</li>
                            <li>嘔吐</li>
                            <li>食慾下降</li>
                            <li>出血導致貧血，繼而引致的虛弱和疲倦</li>
                            <li>如出血嚴重，有機會讓患者吐血、大便帶血甚至變黑</li>
                        </ul>
                    </Content>
                    <Content
                        id='診斷'
                        image={UrlService.getLocalImageUrl('patient-care/h-pylori/section_3_346x713.png')}
                        reducer={[state, dispatch]}
                        next="治療"
                    >
                        <h2>診斷</h2>
                        <div className="table-container">
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>幽門螺旋桿菌測試</th>
                                        <th className="green">優點</th>
                                        <th className="red">缺點</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>侵入性</td>
                                        <td>內窺鏡或組織檢查</td>
                                        <td>
                                            <ul>
                                                <li>可檢查胃部受損程度<sup>7</sup></li>
                                            </ul>
                                        </td>
                                        <td>
                                            <ul>
                                                <li>比較耗時<sup>7</sup></li>
                                                <li>受檢者會感到不適<sup>7</sup></li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>非侵入性</td>
                                        <td>血液檢測</td>
                                        <td>
                                            <ul>
                                                <li>較便宜<sup>7</sup></li>
                                                <li>較方便<sup>7</sup></li>
                                            </ul>
                                        </td>
                                        <td>
                                            <ul>
                                                <li>準確度在60%-100%之間<sup>7e</sup></li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>糞便抗原檢測</td>
                                        <td>
                                            <ul>
                                                <li>在兒童檢測中效率尤其高<sup>7</sup></li>
                                                <li>準確率高達90%以上<sup>7</sup></li>
                                            </ul>
                                        </td>
                                        <td>
                                            <ul>
                                                <li>糞便樣本最多能存放於室溫24小時，否則有機會影響準確度<sup>7</sup></li>
                                                <li>患消化道疾病或出血性潰瘍、質子泵抑制劑(PPI)治療可影響準確度<sup>7</sup></li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>碳13尿素吹氣測試</td>
                                        <td>
                                            <ul>
                                                <li>較簡單及安全<sup>7</sup></li>
                                                <li>準確率高達90%以上<sup>7</sup></li>
                                            </ul>
                                        </td>
                                        <td>
                                            <ul>
                                                <li>以下因素可影響準確度:
                                                        <ul>
                                                        <li>近一個月服用了殺滅幽門螺旋桿菌的抗生素<sup>7 8 9</sup></li>
                                                        <li>近兩週服用了抑制胃酸的藥物<sup>7 8 9</sup></li>
                                                        <li>大量吸煙<sup>10</sup></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr className="table-footer">
                                        <td colSpan={4}>
                                            <h4>碳13尿素吹氣測試</h4>
                                            <p>此項測試大概需時20-30分鐘<sup>9</sup>，流程大概如下：</p>
                                            <ol>
                                                <li>
                                                    測試前一個小時不可飲食，包括水在內的任何食物或飲料<sup>9</sup>
                                                </li>
                                                <li>
                                                    測試開始前，受檢者需用口呼氣進入一個類似氣球的袋子裡，作為比較的基礎
                                                    </li>
                                                <li>
                                                    然後受檢者需要喝進含碳13尿素的液體<sup>9</sup>
                                                </li>
                                                <li>
                                                    15分鐘後再次進行步驟2.，以作比對<sup>9</sup>
                                                </li>
                                            </ol>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Content>
                    <Content
                        id='治療'
                        image={UrlService.getLocalImageUrl('patient-care/h-pylori/section_4_450x465.png')}
                        reducer={[state, dispatch]}
                    >
                        <h2>治療</h2>
                        <p>
                            治療幽門螺旋桿菌的療程為期14天，當中需要結合三種處方藥物才能達到理想功效，包括質子泵抑制劑（PPI）和兩種抗生素：克拉黴素（clarithromycin）和阿莫西林（amoxicillin）或甲硝唑 （metronidazole）<sup>11</sup>。
                        </p>
                        <p>
                            療程進行期間，患者應多吃高纖維和含豐富維他命A的食物，並儘量避免喝咖啡（包括低咖啡因咖啡）和酒精，這些飲食習慣都有助減低腸胃潰瘍的風險<sup>12</sup>。
                        </p>
                    </Content>
                </section>
                <SelfTestSection
                    id='測試'
                    questions={questions}
                    result={HPyloriSelfTestResult}
                />
                <ReferenceListSection references={campaign.data?.references ?? config.references} />
                <section className="approval-code">
                    <div className="container">HK-6084 10/26/2021</div>
                </section>
                {/* <EmailSubscribePopup title="FindDoc 與您同抗心臟疾病" description="想了解多啲二尖瓣倒流？" image={UrlService.getImageUrl("self-tests/mitral-regurgitation/email-subscribe-popup@1x.png")}/> */}
            </div>
        </Layout>
    );
};

export default HPyloriSelfTest;
